import React from 'react'

import { Button, Fieldset } from '@fourthwall/components'
import type { useFormik } from '@fourthwall/utils/dist/formik'

import type { FormValues } from '../../hooks/useBadgeForm/types'
import { FormFields } from '../../hooks/useBadgeForm/types'

type Props = {
  form: ReturnType<typeof useFormik<FormValues>>
}

export const AddCustomStyling = ({ form }: Props) => (
  <Fieldset.Row>
    <Button
      label="Add custom styling"
      appearance="secondary"
      size="small"
      onClick={() => {
        form.setFieldValue(
          FormFields.memberStreakBadges,
          form.values.memberStreakBadges.concat({
            emoji: {
              type: 'Emoji',
              emojiIcon: '😊',
            },
            borderColor: undefined,
            backgroundColor: 'rgba(0,0,0,0)',
            textColor: undefined,
            monthsFrom: 0,
            monthsTo: 1,
          }),
        )
      }}
    />
  </Fieldset.Row>
)
